<template>
  <div :class="currentStyle">
    <bs-template-user v-if="chk_member"></bs-template-user>
    <bs-template-owner v-else-if="chk_owner"></bs-template-owner>
    <bs-template-club v-else-if="chk_club"></bs-template-club>
    <bs-template-logout-view v-else-if="chk_logout"></bs-template-logout-view>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import BsTemplateUser from './BsTemplateUserView.vue'
  import BsTemplateOwner from './BsTemplateOwnerView.vue'
  import BsTemplateClub from './BsTemplateClubView.vue'
  import BsTemplateLogoutView from './BsTemplateLogoutView.vue'
  export default {
    name: 'BsTemplate',
    data: function () {
      return {}
    },
    components: {
      BsTemplateUser,
      BsTemplateLogoutView,
      BsTemplateOwner,
      BsTemplateClub,
    },
    async created() {},
    computed: {
      ...mapState({}),
      currentStyle() {
        if (this.chk_owner) {
          return 'theme-owner' // 主催者用スタイル
        } else if (this.chk_club) {
          return 'theme-club' // 公認クラブ用スタイル
        }
        return 'theme-user' // 一般会員用スタイル
      },
      chk_member: function () {
        if (
          this.auth &&
          this.get_load_type == 'member' &&
          (this.$route.meta.auth_type || {}) == 'member'
        ) {
          return true
        }
        return false
      },
      chk_club: function () {
        if (
          this.auth &&
          this.get_load_type == 'club' &&
          (this.$route.meta.auth_type || {}) == 'club'
        ) {
          return true
        }
        return false
      },
      chk_owner: function () {
        if (
          this.auth &&
          this.get_load_type == 'owner' &&
          (this.$route.meta.auth_type || {}) == 'owner'
        ) {
          return true
        }
        return false
      },
      chk_logout: function () {
        if (
          !this.chk_member &&
          !this.chk_club &&
          !this.chk_owner &&
          (this.$route.meta.auth_type || {}) == 'logout'
        ) {
          return true
        }
        return false
      },
      auth: function () {
        return this.get_load_type == 'owner'
          ? this.$store.state.oauth && this.$store.state.oauth.token
            ? this.$store.state.oauth
            : false
          : this.get_load_type == 'club'
          ? this.$store.state.cauth && this.$store.state.cauth.token
            ? this.$store.state.cauth
            : false
          : this.get_load_type == 'member'
          ? this.$store.state.auth && this.$store.state.auth.token
            ? this.$store.state.auth
            : false
          : false
      },
    },
  }
</script>
<style>
  @import '../../assets/css/style.css';
  /*!
  Copyright (c) MotherHeads LLC. All Rights Reserved.
*/
  :root {
    /* デフォルトのカラー設定 */
    --color01: #000000;
    --color02: #ffffff;
    --color03: #cb000b; /* デフォルト：一般会員用 */
    --color04: #fffaed;
    --color05: #e0a2a2;
    --color06: #888888;
    --color07: #f4f4f4;
    --color08: #cccccc;
  }

  /* 主催者用テーマ */
  .theme-owner {
    --color03: #0640e0;
  }

  /* 公認クラブ用テーマ */
  .theme-club {
    --color03: #e38c01;
    /* --color03: #e3c901; */
  }

  /* 一般会員用テーマ（必要な場合） */
  .theme-user {
    --color03: #cb000b;
  }
</style>
